import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import * as keyCodeApi from '../api/keyCodeApi';

// TODO: define this
interface DisableReason {
  id: string;
  [key: string]: any;
}

type DisableReasonsState = DisableReason[] | null;

export const saveDisableReason = createAsyncThunk<
  DisableReason,
  DisableReason,
  {
    dispatch: any;
  }
>('disableReasons/save', async (disableReason, { dispatch }) => {
  const savedDisableReason = (await keyCodeApi.saveDisableReason(
    disableReason
  )) as { id: string };

  const completeDisableReason = {
    ...disableReason,
    id: savedDisableReason.id,
  };

  if (disableReason.id) {
    dispatch(updateDisableReason(completeDisableReason));
  } else {
    dispatch(createDisableReason(completeDisableReason));
  }

  return completeDisableReason;
});

export const fetchDisableReasons = createAsyncThunk<DisableReason[], void>(
  'disableReasons/fetchAll',
  async (_, { dispatch }) => {
    const response = (await keyCodeApi.getAllDisableReasons()) as {
      data: DisableReason[];
    };

    const disableReasons = response.data.sort(
      (a: DisableReason, b: DisableReason) => (a.reason > b.reason ? 1 : -1)
    );

    dispatch(loadDisableReasons(disableReasons));

    return disableReasons;
  }
);

export const removeDisableReason = createAsyncThunk<string, string>(
  'disableReasons/delete',
  async (id, { dispatch }) => {
    await keyCodeApi.deleteDisableReason(id);

    dispatch(deleteDisableReason(id));

    return id;
  }
);

const disableReasonsSlice = createSlice({
  name: 'disableReasons',
  initialState: null as DisableReasonsState,
  reducers: {
    loadDisableReasons: (_, action: PayloadAction<DisableReason[]>) => {
      return action.payload;
    },
    updateDisableReason: (state, action: PayloadAction<DisableReason>) => {
      if (state === null) return state;

      return state.map((disableReason) =>
        disableReason.id === action.payload.id ? action.payload : disableReason
      );
    },
    createDisableReason: (state, action: PayloadAction<DisableReason>) => {
      if (state === null) return state;

      return [...state, action.payload];
    },
    deleteDisableReason: (state, action: PayloadAction<string>) => {
      if (state === null) return state;

      return state.filter(
        (disableReason) => disableReason.id !== action.payload
      );
    },
  },
});

export const {
  loadDisableReasons,
  updateDisableReason,
  createDisableReason,
  deleteDisableReason,
} = disableReasonsSlice.actions;

export default disableReasonsSlice.reducer;
